import React, { FC } from 'react'
import { AppBar, AppBarProps } from '@mui/material'

export const EvtAppBar: FC<AppBarProps> = ({ children, ...props }) => {
    return <AppBar {...props}>{children}</AppBar>
}

export default EvtAppBar
